import type { ReactNode } from "react";

interface Props {
    title: string;
    value: string;
    icon: ReactNode;
}

export default function StatisticsCard({ title, value, icon }: Props) {
    return (
        <div className="stat-card">
            <div className="stat-card__head">
                <span className="stat-card__title">{title}</span>
                <span className="stat-card__icon">{icon}</span>
            </div>
            <div className="stat-card__value">{value}</div>
        </div>
    );
}
